import React from 'react'

function Footer() {
  const cYear = new Date().getFullYear();
  return (
    <>
      <footer className="app-footer">
        <div className="List-Container">

          <ul className="CP-list">
            <h3 className="CP">Company</h3>
            <li className="list-items"><a href="">About Us</a></li>
            <li className="list-items"><a href="">Pricing</a></li>
            <li className="list-items" ><a href="">Careers</a></li>
          </ul>

          <ul className="RS-list">
            <h3 className="RS">Resources</h3>
            <li className="list-items"><a href="">Blog</a></li>
            <li className="list-items"><a href="">FAQs</a></li>
            <li className="list-items"><a href="">Support</a></li>
          </ul>

          <ul className="LG-list">
            <h3 className="LG">Legal</h3>
            <li className="list-items"><a href="">Terms of service</a></li>
            <li className="list-items"><a href="">Privacy Policy</a></li>
            <li className="list-items"><a href="">Contact</a></li>
          </ul>
        </div>

        <p className="footer-P">All Rights Reserved &copy; {cYear}</p>

      </footer>
    </>
  )
}

export default Footer
